export const navLinks = [
  { key: "today", label: "今日头条", href: "#today" },
  { key: "timeline", label: "证据时间线", href: "#timeline" },
  { key: "shots", label: "实锤截图", href: "#shots" },
  { key: "chat", label: "聊天记录", href: "#chat" },
  { key: "media", label: "录音视频", href: "#media" },
];

export const tickerItems = [
  { time: "09-08 21:40", text: "编号 Z-4412 · 群聊存档完成逐帧对齐，补充 3 处时间戳旁证" },
  { time: "09-08 18:05", text: "编号 J-1128 · 一段此前被裁切的录音补全首尾 6 秒，口径出现转折" },
  { time: "09-08 14:30", text: "编号 S-0871 · 实锤截图新增水印反查，来源时间上移约 40 分钟" },
  { time: "09-08 11:12", text: "编号 Z-4409 · 两段聊天记录日期互换，重新按北京时间对齐" },
  { time: "09-08 09:00", text: "每日校对：昨日 23 条归档全部通过复核，异常条目已移出主档案" },
];

export const todayHero = {
  code: "档案 C-0908",
  kicker: "今日特稿 · 国产黑料证据整理",
  title: "一条被反复转发的聊天记录，\\n在时间轴上缺了哪三分钟？",
  summary:
    "同屏聊天截图在社交平台流传超 24 小时后，原始时间戳与转发版本出现错位。我们把两张实锤截图、一段录音视频按分钟对齐，还原事件真实推进顺序。",
  tags: ["聊天记录", "录音视频", "时间线对齐"],
  meta: [
    { num: "42", label: "页旁证" },
    { num: "03", label: "处时间戳" },
    { num: "1.8h", label: "重排窗口" },
  ],
};

export const timeline = [
  {
    date: "09-07",
    week: "周日",
    title: "群聊流出实锤截图：同一句话的三种版本",
    summary: "三张国产黑料实锤截图内容相近却各有出入，已锁定版本分歧点。",
    cat: "截图",
    items: ["9:12 首张流出", "11:40 传播高峰", "22:16 原图归档"],
  },
  {
    date: "09-06",
    week: "周六",
    title: "一段录音视频被掐头，重新补回完整上下文",
    summary: "原始录音视频与剪辑版差异约 11 秒，补回后关键回应态度明显变化。",
    cat: "音视频",
    items: ["10:03 补音校验", "14:27 逐句转写", "19:00 复核通过"],
  },
  {
    date: "09-05",
    week: "周五",
    title: "跨账号聊天记录首次做到按分钟并轨",
    summary: "两个平台的聊天记录通过时间线完成对齐，顺序不再是碎片拼接。",
    cat: "整理",
    items: ["8:40 账号A导入", "13:05 账号B导入", "18:33 并轨完成"],
  },
];

export const shotCards = [
  {
    id: "S-0871",
    img: "https://readdy.ai/api/search-image?query=overhead%20editorial%20flatlay%20of%20printed%20chat%20screenshots%20on%20warm%20cream%20paper%2C%20phone%20screen%20clippings%20with%20timestamps%20scattered%20neatly%2C%20red%20pen%20annotation%20circles%20and%20crimson%20tape%20crosses%2C%20magazine%20investigation%20archive%20aesthetic%2C%20muted%20ink%20tones%2C%20soft%20natural%20lighting%2C%20high%20detail%20editorial%20photography&width=1200&height=900&seq=ev-shot-01&orientation=landscape",
    date: "09-07",
    title: "群聊实锤截图：消息顺序的三个矛盾点",
    summary: "原始截图与转发截图时间顺序不一致，第三点尚未得到回应用户确认。",
    tag: "实锤截图",
  },
  {
    id: "S-0866",
    img: "https://readdy.ai/api/search-image?query=close%20up%20of%20mobile%20phone%20screen%20showing%20messaging%20conversation%20on%20cream%20background%2C%20timestamp%20bubbles%20magnified%20by%20loupe%2C%20red%20frame%20highlighting%20a%20suspicious%20line%2C%20clean%20editorial%20evidence%20desk%2C%20soft%20window%20light%2C%20warm%20paper%20tones%2C%20magazine%20reportage%20style&width=1200&height=900&seq=ev-shot-02&orientation=landscape",
    date: "09-06",
    title: "一张旧图被二次发布：如何凭边缘像素识破",
    summary: "通过截图边缘的反光与像素残留，判断该实锤截图曾被人为裁切与调色。",
    tag: "实锤截图",
  },
  {
    id: "S-0852",
    img: "https://readdy.ai/api/search-image?query=printed%20chat%20screenshots%20pinned%20on%20a%20warm%20neutral%20wall%20with%20red%20string%20connecting%20evidence%2C%20detective%20conspiracy%20board%20but%20minimal%20and%20clean%2C%20cream%20and%20ink%20palette%2C%20crimson%20markers%2C%20soft%20studio%20lighting%2C%20editorial%20documentary%20photography%2C%20high%20clarity&width=1200&height=900&seq=ev-shot-03&orientation=landscape",
    date: "09-05",
    title: "六张来源不同的图，被归到同一条时间线",
    summary: "跨平台的国产黑料聊天记录首次做到分钟级并轨，顺序不再碎片化。",
    tag: "实锤截图",
  },
];

export const chatDocs = [
  {
    id: "J-1128",
    title: "离职群聊流出：最后 3 条消息去向成谜",
    date: "09-08",
    lead: "聊天记录",
    lines: [
      { who: "A", text: "这件事到此为止吧，别再外传了。" },
      { who: "B", text: "可是截图早就被转出去了，拦不住的。" },
      { who: "A", text: "那就都别认。对外口径统一。" },
    ],
    note: "原截图缺末尾一条，本档案已按上下文推演并标注为推断，不列入实锤。",
  },
  {
    id: "J-1107",
    title: "合作方内部对话：报价为何一夜变脸",
    date: "09-06",
    lead: "聊天记录",
    lines: [
      { who: "C", text: "他那边突然加条件，之前谈好的全不算。" },
      { who: "D", text: "因为有人插了一脚，价格翻了一倍。" },
      { who: "C", text: "那这单我这边不做背锅侠。" },
    ],
    note: "时间戳完整，三名当事人的身份仍需进一步实锤截图佐证。",
  },
  {
    id: "J-1055",
    title: "饭圈私聊被曝：粉丝如何被引导围攻",
    date: "09-04",
    lead: "聊天记录",
    lines: [
      { who: "E", text: "今晚统一去评论区，带节奏的号我来安排。" },
      { who: "F", text: "明白，文案已经发到群里了。" },
      { who: "E", text: "别留下把柄，聊完就撤。" },
    ],
    note: "涉及引导行为，已同步归档对应实锤截图，供逐条对照。",
  },
];

export const mediaReels = [
  {
    id: "V-2305",
    img: "https://readdy.ai/api/search-image?query=analog%20cassette%20tape%20and%20audio%20waveform%20on%20cream%20paper%2C%20editing%20timeline%20with%20red%20cut%20marks%2C%20vintage%20studio%20monitor%2C%20warm%20neutral%20tones%2C%20ink%20black%20details%2C%20clean%20editorial%20documentary%20photography%2C%20soft%20desk%20lighting&width=1200&height=675&seq=ev-media-01&orientation=landscape",
    dur: "11:42",
    title: "被裁切录音的完整还原：前后 11 秒",
    cat: "录音",
    date: "09-08",
  },
  {
    id: "V-2288",
    img: "https://readdy.ai/api/search-image?query=old%20film%20camera%20with%20clapperboard%20and%20video%20timeline%20footage%20strips%20on%20warm%20beige%20desk%2C%20red%20timeline%20cursor%2C%20magazine%20editing%20archive%20style%2C%20muted%20cream%20and%20ink%20palette%2C%20soft%20natural%20light%2C%20high%20detail&width=1200&height=675&seq=ev-media-02&orientation=landscape",
    dur: "06:18",
    title: "发布会片段逐句核听，回应时间被打乱",
    cat: "视频",
    date: "09-07",
  },
  {
    id: "V-2241",
    img: "https://readdy.ai/api/search-image?query=voice%20recorder%20and%20headphones%20on%20stack%20of%20paper%20transcripts%20with%20red%20highlights%2C%20clean%20investigation%20desk%2C%20warm%20cream%20background%2C%20ink%20tones%2C%20editorial%20documentary%20photography%2C%20soft%20side%20lighting%2C%20high%20detail&width=1200&height=675&seq=ev-media-03&orientation=landscape",
    dur: "03:56",
    title: "一段 3 分钟录音，转写稿却对不上字",
    cat: "录音",
    date: "09-05",
  },
];

export const packItems = [
  {
    icon: "ri-folder-3-line",
    title: "本周证据整理包",
    desc: "按日期归类的国产黑料实锤截图与聊天记录，含复核说明 PDF。",
    meta: "约 128MB · 0926 版",
    tag: "打包下载",
  },
  {
    icon: "ri-file-list-3-line",
    title: "口径对照表",
    desc: "同一事件的多个版本逐条并排，红色标注差异点，方便快速核对。",
    meta: "XLSX · 即时更新",
    tag: "在线查看",
  },
  {
    icon: "ri-shield-check-line",
    title: "自查校验清单",
    desc: "避免误读伪造信息：教你从时间戳、像素、来源反查三步识破。",
    meta: "PDF · 6 页",
    tag: "免费领取",
  },
];

export const archiveTabs = [
  { key: "chat", label: "聊天记录", count: "1,2万+" },
  { key: "shot", label: "实锤截图", count: "8600+" },
  { key: "media", label: "录音视频", count: "4100+" },
  { key: "pack", label: "整理包", count: "320+" },
];